import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    font-size: 10px;\n    color: ", ";\n    cursor: pointer;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 30px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    > h3 {\n        width: 20%;\n        margin-left: 0 !important;\n        font-size: ", ";\n        color: ", ";\n        overflow: hidden;\n        text-overflow: ellipsis;\n        text-align: center;\n        transition: none;\n    }\n    h3:nth-of-type(2) {\n        width: 30%;\n        color: ", ";\n        font-size: inherit;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    overflow: auto;\n    position: relative;\n    display: flex;\n    flex-wrap: nowrap;\n    -webkit-overflow-scrolling: touch;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n\n    ::-webkit-scrollbar {\n        display: none;\n    }\n\n    &:after {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        content: '';\n        display: block;\n        height: 1px;\n        width: 100%;\n        opacity: 0.2;\n        background: #bccacb;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Icon } from '../../Atoms';
export var StyledTabTitles = styled.div(_templateObject());
export var StyledResponsiveTabTitles = styled.div(_templateObject2(), function (_ref) {
  var theme = _ref.theme;
  return theme.global.typographyConfig.body.regular.fontSize;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.global.colors.doveGrayLight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.global.colors.black;
});
export var StyledTabContent = styled.div(_templateObject3());
export var StyledTabs = styled.div(_templateObject4());
export var StyledIcon = styled(Icon)(_templateObject5(), function (props) {
  return props.theme.global.colors.doveGray;
});